// ----------------------------------------------------------------------

export default function CalendarPicker(theme) {
  return {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        content: {
          minWidth: 270,

          [theme.breakpoints.up('xl')]: {
            width: 320,
          },
        },
      },
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          position: 'relative',
          width: 270,
          [theme.breakpoints.up('xl')]: {
            width: 320,
          },
        },
      },
    },
    MuiDayPicker: {
      styleOverrides: {
        header: { marginTop: 15, backgroundColor: 'rgb(240 240 247 / 51%)' },
        weekDayLabel: {
          height: 35,
          width: 30,

          [theme.breakpoints.up('xl')]: {
            width: 35,
          },
        },
      },
      slideTransition: {
        minHeight: 200,
      },
    },
    // MuiPickersArrowSwitcher: {
    //   styleOverrides: {
    //     spacer: { width: 70 },
    //   },
    // },
    // MuiPickersCalendarHeader: {
    //   styleOverrides: {
    //     root: { paddingRight: 0, marginTop: 0 },
    //     switchViewButton: {
    //       display: 'none',
    //     },
    //     label: {
    //       fontWeight: 400,
    //     },
    //     labelContainer: {
    //       opacity: 0,
    //     },
    //   },
    // },
  };
}
